<template>

<app-table-cell class="capacity">

    <app-icon icon="user" v-for="person in max" :key="person" class="capacity-item" :class="{'is-taken': person <= taken, 'is-selected': selected && person === taken + 1, 'is-active': active && person === taken}" v-tooltip="tooltip(person)" />
    
</app-table-cell>
    
</template>
    
<script>
    
export default {
    
    props: ['max', 'taken', 'active', 'selected'],

    methods: {
    
        tooltip: function(index) {

            if ((index === this.taken + 1 && this.selected) || this.active) {
            
                return 'Selected'            
            
            } else if(index <= this.taken) {
            
                return 'Taken'
            
            } else {
            
                return 'Available'
            
            }
        
        }
    
    }
    
}
    
</script>
    
<style scoped>
    
.capacity {
    display: flex;
}

.capacity-item {
    border-radius: 50%;
    height: 24px;
    width: 24px;
    color: #fff;
    background-color: #eee;
    text-align: center;
    line-height: 24px;
    font-size: 12px;
    margin-right: 2px;
    flex-wrap: wrap;
}

.capacity-item.is-taken {
    background-color: #333;
}

.capacity-item.is-selected {
    background-color: #4faa80;
}

.capacity-item.is-active {
    background-color: #4faa80;
}
    
</style>